import React, { useState } from "react";
import {
  DndContext,
  closestCenter,
  MouseSensor,
  TouchSensor,
  DragOverlay,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  rectSortingStrategy,
} from "@dnd-kit/sortable";

import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";

import { Grid } from "./Grid";
import { SortablePhoto } from "./SortablePhoto";
import { Photo } from "./Photo";

// Styled components
const BottomLeft = styled("span")(({ theme }) => ({
  bottom: "10%",
  position: "relative",
}));

const CustomButtonChip = (props) => {
  const { onDelete = () => {}, ...otherProps } = props;
  const [showDelete, setShowDelete] = useState(false);
  return (
    <Chip
      {...otherProps}
      onMouseEnter={() => setShowDelete(true)}
      onMouseLeave={() => setShowDelete(false)}
      onDelete={showDelete ? onDelete : undefined}
      sx={{ "& .MuiChip-deleteIcon": { color: "red" } }}
    />
  );
};

const Gallery = (props) => {
  const { items = [], onSortHandler = () => {}, onRemove = () => {} } = props;
  const [activeId, setActiveId] = useState(null);
  const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor));

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragCancel={handleDragCancel}
    >
      <SortableContext items={items} strategy={rectSortingStrategy}>
        <Grid columns={6}>
          {items.map(({ name: url, type }, index) => (
            <span key={url}>
              <SortablePhoto url={url} index={index} />
              <BottomLeft>
                <CustomButtonChip
                  label={`${index + 1} ${type === "video" ? "(video)" : ""}`}
                  onDelete={() => onRemove(url)}
                />
              </BottomLeft>
            </span>
          ))}
        </Grid>
      </SortableContext>

      <DragOverlay adjustScale={true}>
        {activeId ? (
          <Photo
            url={activeId}
            index={items.find(({ name }) => name === activeId.name)}
          />
        ) : null}
      </DragOverlay>
    </DndContext>
  );

  function handleDragStart(event) {
    setActiveId(event.active.id);
  }

  function handleDragEnd(event) {
    const { active, over } = event;
    if (active.id !== over?.id) {
      const oldIndex = items.findIndex(({ name }) => name === active.id);
      const newIndex = items.findIndex(({ name }) => name === over.id);
      const newArr = arrayMove(items, oldIndex, newIndex);
      onSortHandler(newArr);
    }
    setActiveId(null);
  }

  function handleDragCancel() {
    setActiveId(null);
  }
};

export default Gallery;
